import React from 'react';
import * as XLSX from 'xlsx';

const PreLaminationView = () => {
  const inspectionData = JSON.parse(sessionStorage.getItem('inspectionData') || '{}');
  const preLamination = inspectionData.PreLamination;

  if (!preLamination) {
    return <p className="text-gray-500">No PreLamination data available</p>;
  }

  // Function to download data as Excel
  const downloadExcel = () => {
    const workbook = XLSX.utils.book_new();
    const worksheetData = [];

    // Headers for the Excel sheet
    worksheetData.push([
      'Section',
      'Sub-Section',
      'Product',
      'Frequency',
      'Observation 1',
      'Observation 2',
      'Specifications',
      'Non-Conformance',
    ]);

    // Populate data for each section and sub-section
    Object.entries(preLamination).forEach(([sectionKey, sectionData]) => {
      const sectionName = sectionKey.replace(/_pre$/, '').replace(/([A-Z])/g, ' $1').trim();
      let nonConformance = 'N/A';

      Object.entries(sectionData).forEach(([subKey, subData]) => {
        if (subKey === 'nonConformance') {
          nonConformance = subData || 'N/A';
        } else if (Array.isArray(subData)) {
          // Direct array under section (e.g., shopFloor_pre > array)
          const subSectionName = subKey.replace(/([A-Z])/g, ' $1').trim();
          subData.forEach((item) => {
            worksheetData.push([
              sectionName,
              subSectionName,
              item.product || 'N/A',
              item.frequency || 'N/A',
              item.observation1 || 'N/A',
              item.observation2 || 'N/A',
              item.specifications || 'N/A',
              nonConformance,
            ]);
          });
        } else {
          // Nested object with arrays (e.g., encapsulationMaterialFront_pre > visualInspection > array)
          Object.entries(subData).forEach(([subNestedKey, subNestedData]) => {
            if (Array.isArray(subNestedData)) {
              const subSectionName = subNestedKey.replace(/([A-Z])/g, ' $1').trim();
              subNestedData.forEach((item) => {
                worksheetData.push([
                  sectionName,
                  subSectionName,
                  item.product || 'N/A',
                  item.frequency || 'N/A',
                  item.observation1 || 'N/A',
                  item.observation2 || 'N/A',
                  item.specifications || 'N/A',
                  nonConformance,
                ]);
              });
            }
          });
        }
      });
    });

    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    XLSX.utils.book_append_sheet(workbook, worksheet, 'PreLamination');
    XLSX.writeFile(workbook, 'PreLaminationData.xlsx');
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-2xl font-semibold text-gray-800">Pre-Lamination Data</h2>
        <button
          onClick={downloadExcel}
          className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 focus:outline-none"
        >
          Download Excel
        </button>
      </div>

      {Object.entries(preLamination).map(([sectionKey, sectionData]) => (
        <div key={sectionKey} className="border-b pb-4">
          <h3 className="text-xl font-semibold text-gray-800 mb-4">
            {sectionKey.replace(/_pre$/, '').replace(/([A-Z])/g, ' $1').trim()}
          </h3>
          {Object.entries(sectionData).map(([subKey, subData]) => {
            if (subKey === 'nonConformance') {
              return (
                <div key={subKey} className="mt-4">
                  <h4 className="font-semibold text-gray-700">Non-Conformance</h4>
                  <p className="text-gray-600">{subData || 'N/A'}</p>
                </div>
              );
            }
            if (Array.isArray(subData)) {
              return (
                <div key={subKey} className="mt-4">
                  <h4 className="font-semibold text-gray-700 mb-2">
                    {subKey.replace(/([A-Z])/g, ' $1').trim()}
                  </h4>
                  <div className="overflow-x-auto">
                    <table className="min-w-full bg-white border rounded-lg">
                      <thead>
                        <tr className="bg-gray-100">
                          <th className="px-4 py-2 text-left text-gray-700">Product</th>
                          <th className="px-4 py-2 text-left text-gray-700">Frequency</th>
                          <th className="px-4 py-2 text-left text-gray-700">Observation 1</th>
                          <th className="px-4 py-2 text-left text-gray-700">Observation 2</th>
                          <th className="px-4 py-2 text-left text-gray-700">Specifications</th>
                        </tr>
                      </thead>
                      <tbody>
                        {subData.map((item, index) => (
                          <tr key={index} className="border-t">
                            <td className="px-4 py-2 text-gray-600">{item.product || 'N/A'}</td>
                            <td className="px-4 py-2 text-gray-600">{item.frequency || 'N/A'}</td>
                            <td className="px-4 py-2 text-gray-600">{item.observation1 || 'N/A'}</td>
                            <td className="px-4 py-2 text-gray-600">{item.observation2 || 'N/A'}</td>
                            <td className="px-4 py-2 text-gray-600">{item.specifications || 'N/A'}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              );
            }
            return null;
          })}
          {Object.entries(sectionData).some(([k]) => k !== 'nonConformance' && !Array.isArray(sectionData[k])) && (
            Object.entries(sectionData).map(([nestedKey, nestedData]) => {
              if (nestedKey !== 'nonConformance' && !Array.isArray(nestedData)) {
                return Object.entries(nestedData).map(([subNestedKey, subNestedData]) => {
                  if (Array.isArray(subNestedData)) {
                    return (
                      <div key={subNestedKey} className="mt-4">
                        <h4 className="font-semibold text-gray-700 mb-2">
                          {subNestedKey.replace(/([A-Z])/g, ' $1').trim()}
                        </h4>
                        <div className="overflow-x-auto">
                          <table className="min-w-full bg-white border rounded-lg">
                            <thead>
                              <tr className="bg-gray-100">
                                <th className="px-4 py-2 text-left text-gray-700">Product</th>
                                <th className="px-4 py-2 text-left text-gray-700">Frequency</th>
                                <th className="px-4 py-2 text-left text-gray-700">Observation 1</th>
                                <th className="px-4 py-2 text-left text-gray-700">Observation 2</th>
                                <th className="px-4 py-2 text-left text-gray-700">Specifications</th>
                              </tr>
                            </thead>
                            <tbody>
                              {subNestedData.map((item, index) => (
                                <tr key={index} className="border-t">
                                  <td className="px-4 py-2 text-gray-600">{item.product || 'N/A'}</td>
                                  <td className="px-4 py-2 text-gray-600">{item.frequency || 'N/A'}</td>
                                  <td className="px-4 py-2 text-gray-600">{item.observation1 || 'N/A'}</td>
                                  <td className="px-4 py-2 text-gray-600">{item.observation2 || 'N/A'}</td>
                                  <td className="px-4 py-2 text-gray-600">{item.specifications || 'N/A'}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    );
                  }
                  return null;
                });
              }
              return null;
            })
          )}
        </div>
      ))}
    </div>
  );
};

export default PreLaminationView;